import { SvgIcon } from '@material-ui/core';
import React from 'react';

/* eslint-disable max-len */
const CHECK_PATH = 'M5.5 12.5 L9.5 16.5 L18.5 7.5';
const CENTER_SPARKLE = 'M12 1 L12.4 3.2 L14.2 2.2 L12.8 4 L15 4.4 L12.8 5 L14.2 6.8 L12.4 5.8 L12 8 L11.6 5.8 L9.8 6.8 L11.2 5 L9 4.4 L11.2 4 L9.8 2.2 L11.6 3.2 Z';
const LEFT_SPARKLE = 'M5.5 4.5 L5.75 5.8 L7 5.1 L6.1 6 L7.3 6.25 L6.1 6.5 L7 7.4 L5.75 6.7 L5.5 8 L5.25 6.7 L4 7.4 L4.9 6.5 L3.7 6.25 L4.9 6 L4 5.1 L5.25 5.8 Z';
const RIGHT_SPARKLE = 'M18.5 2 L18.75 3.3 L20 2.6 L19.1 3.5 L20.3 3.75 L19.1 4 L20 4.9 L18.75 4.2 L18.5 5.5 L18.25 4.2 L17 4.9 L17.9 4 L16.7 3.75 L17.9 3.5 L17 2.6 L18.25 3.3 Z';
/* eslint-enable max-len */

/**
 * Orion sidebar icon — a checkmark with three sparkles above it,
 * matching the orion favicon.
 */
export function OrionIcon(): JSX.Element {
  return (
    <SvgIcon
      viewBox="0 0 24 24"
      style={{ height: 22, width: 22 }}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
      >
        <path
          d={CHECK_PATH}
          fill="none"
          stroke="currentColor"
          strokeWidth="2.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path d={CENTER_SPARKLE} fill="currentColor" />
        <path d={LEFT_SPARKLE} fill="currentColor" />
        <path d={RIGHT_SPARKLE} fill="currentColor" />
      </svg>
    </SvgIcon>
  );
}
